import React, { useEffect } from 'react';
import './LandingPage.scss';
import { useHistory } from 'react-router-dom';
import regions from './../sernapesca.json'

const LandingPage = () => {
    /**
     * Vista Home
     * Muestra un mapa con las diferentes regiones del país Chile
     */
    let history = useHistory();
    regions.sort((a, b) => {
        if (a.cdRegion < b.cdRegion) {
            return -1
        } else {
            return 1
        }
    })
    useEffect(() => {
    }, []);
    function toTitleCase(str) {
        return str.replace(
            /\w\S*/g,
            function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
    }

    return (
        <div className="regions">
            {
                regions.map((img) => {
                    return (
                        <div className="item" style={{height:img.maxHeight, backgroundImage: `url(${require("../../assets/mapa/" + img.photo)})`}} key={img.cdRegion} onClick={() => {
                            history.push('/region/' + img.cdRegion + "/" + img.filter.replace(/\s/g, '-') )
                        }} >
                            <span style={{ backgroundColor: `#${img.color}` }} className="text notranslate">{"Región " + img.name}</span>
                        </div>
                    )
                })
            } 
        </div>
    )
}

export default LandingPage;